<template>
  <v-menu attach origin="top right" left v-if="severity" offset-y :close-on-content-click="false"
          :min-width="menuWidth" :max-width="menuWidth"
          transition="scale-transition" v-model="open" max-height="85vh">
    <v-btn class="primary-text" icon slot="activator">
      <v-icon :color="severityColor">
        {{severityIcon}}
      </v-icon>
    </v-btn>
    <announcement-panel :severity-color-list="severityColorList" :severity-icon-list="severityIconList"
                        :announcements="announcements"/>
  </v-menu>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import { GET_ANNOUNCEMENTS_SEVERITY } from '../../store/getter-types'
  import AnnouncementPanel from './AnnouncementPanel'

  export default {
    name: 'announcement-icon',
    components: {AnnouncementPanel},
    props: [],
    mixins: [],
    data () {
      return {
        severityIconList: {
          INFO: 'info',
          WARNING: 'warning',
          ERROR: 'error',
          CRITICAL: 'priority_high'
        },
        severityColorList: {
          INFO: '',
          WARNING: 'warning',
          ERROR: 'error',
          CRITICAL: 'error'
        },
        open: false
      }
    },
    methods: {},
    computed: {
      ...mapState({
        announcements: state => state.announcement.announcements
      }),
      ...mapGetters({
        severity: GET_ANNOUNCEMENTS_SEVERITY
      }),
      severityIcon () {
        return this.severityIconList[this.severity]
      },
      severityColor () {
        return this.severityColorList[this.severity]
      },
      menuWidth () {
        return this.$vuetify.breakpoint.smAndDown ? 240 : 480
      }
    },
    watch: {}
  }
</script>




// WEBPACK FOOTER //
// src/components/announcement/AnnouncementIcon.vue